import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var SectionDisplayType = /*#__PURE__*/function () {
  function SectionDisplayType() {
    _classCallCheck(this, SectionDisplayType);
  }

  _createClass(SectionDisplayType, null, [{
    key: "isList",
    value: function isList(displayType) {
      return displayType === this.List;
    }
  }, {
    key: "isCarousel",
    value: function isCarousel(displayType) {
      return displayType === this.Carousel;
    }
  }]);

  return SectionDisplayType;
}();

_defineProperty(SectionDisplayType, "List", 'list');

_defineProperty(SectionDisplayType, "Carousel", 'carousel');